import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact4">

      {/* ================= HERO ================= */}
      <section className="c4-hero">
        <h1>Contact Us</h1>
        <p>We’re here to help you glow, grow & get moving.</p>

        {/* floating shapes */}
        <div className="c4-blob cb1"></div>
        <div className="c4-blob cb2"></div>
      </section>


      {/* ================= CONTACT GRID ================= */}
      <section className="c4-info">
        
        <div className="info-card">
          <h2>Address</h2>
          <p>Shank Fitness Center<br/> 22 Sunshine Street, Level 3<br/> Downtown, LA 90210</p>
        </div>

        <div className="info-card">
          <h2>Call Us</h2>
          <p>+1 (800) 782 - SHANK<br/>Mon – Sat: 7am – 10pm</p>
        </div>

        <div className="info-card">
          <h2>Email</h2>
          <p>support@shankfitness.com<br/>training@shankfitness.com</p>
        </div>

      </section>


      {/* ================= GOOGLE MAP ================= */}
      <section className="c4-map-section">
        <h2>Find Us</h2>

        <div className="c4-map-container">
          <iframe
            title="location-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.8847435220814!2d-118.24368448478182!3d34.05223438060801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c7b948dfbbb1%3A0x8d37c2f2b29f4b2a!2sLos%20Angeles%20Downtown!5e0!3m2!1sen!2sus!4v1690912345678"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

    </div>
  );
};

export default Contact;
